import React from 'react';
import { ReactComponent as MapPointIcon } from 'assets/icons/map-point.svg';
import { useTranslation } from 'react-i18next';
import './ServiceUnavailable.style.scss';

interface IServiceUnavailableProps {
  serviceName: string
  availableRegions: string[]
}

const ServiceUnavailable: React.FC<IServiceUnavailableProps> = ({
  serviceName,
  availableRegions,
}) => {
  const [t] = useTranslation();
  return (
    <div className="service-unavailable">
      <MapPointIcon />
      <p>
        {t('common.service_disabled_1')}
        <span>{` "${serviceName}" `}</span>
        {t('common.service_disabled_2')}
        <span>{` ${availableRegions.join(', ')}`}</span>
      </p>
    </div>
  );
};

export default ServiceUnavailable;
